import images from 'assets/images';
import React from 'react';
import { Container } from '@mui/system';
import { howItWorksTimeLineObj } from 'assets/animation/portalAnimation';
import Slider from 'react-slick';
import { Typography } from '@mui/material';
import { NextArrow, PrevArrow } from 'shared/Icons';

const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 900,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
};

const HowItWorks: React.FC = () => {
    const howItWorksTimeLine = React.useRef(null);
    React.useEffect(() => {
        howItWorksTimeLineObj(howItWorksTimeLine);
    }, []);

    return (
        <section className="how-it-works" ref={howItWorksTimeLine}>
            <Container maxWidth="lg">
                <Typography variant="h3" className="section-title">
                    how Healthreach can work for clinicians
                </Typography>
                <div className="primary-slider">
                    <Slider {...settings}>
                        <div className="card-outer">
                            <div className="card">
                                <div className="img-block">
                                    <span>
                                        <img src={images.slider1} alt="Image" />
                                    </span>
                                </div>
                                <div className="card-content">
                                    <h6>Support for new clinicians</h6>
                                    <p>
                                        Unfamiliar with private practice? Let our team help you every step of the way.
                                        From virtual office setup, learning medicare billing, to tax reporting, we will
                                        be with you every step of the way.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="card-outer">
                            <div className="card">
                                <div className="img-block">
                                    <span>
                                        <img src={images.slider2} alt="Image" />
                                    </span>
                                </div>
                                <div className="card-content">
                                    <h6>Virtual office</h6>
                                    <p>
                                        Our platform will help you have a flexible lifestyle, allowing you to attend to
                                        essential things in your life without compromising your practice or income.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="card-outer">
                            <div className="card">
                                <div className="img-block">
                                    <span>
                                        <img src={images.slider3} alt="Image" />
                                    </span>
                                </div>
                                <div className="card-content">
                                    <h6>Referral management</h6>
                                    <p>Use your own referral sources, or use Healthreach’s established network.</p>
                                </div>
                            </div>
                        </div>
                        <div className="card-outer">
                            <div className="card">
                                <div className="img-block">
                                    <span>
                                        <img src={images.slider4} alt="Image" />
                                    </span>
                                </div>
                                <div className="card-content">
                                    <h6>Full administrative support</h6>
                                    <p>
                                        You can practice from anywhere, anytime, and our invisible team will take care
                                        of all the complex administrative tasks, leaving you to enjoy your life. Think
                                        of the savings and cost reductions that you can achieve.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="card-outer">
                            <div className="card">
                                <div className="img-block">
                                    <span>
                                        <img src={images.slider5} alt="Image" />
                                    </span>
                                </div>
                                <div className="card-content">
                                    <h6>Low cost, no commitment</h6>
                                    <p>
                                        No ongoing cost. We outcompete other clinic models and pass the savings to you.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="card-outer">
                            <div className="card">
                                <div className="img-block">
                                    <span>
                                        <img src={images.slider6} alt="Image" />
                                    </span>
                                </div>
                                <div className="card-content">
                                    <h6>Secure video-conferencing system with simultaneous notes taking</h6>
                                    <p>Use pre-made or your own customized templates</p>
                                </div>
                            </div>
                        </div>
                        <div className="card-outer">
                            <div className="card">
                                <div className="img-block">
                                    <span>
                                        <img src={images.slider7} alt="Image" />
                                    </span>
                                </div>
                                <div className="card-content">
                                    <h6>Easy correspondence system</h6>
                                    <p>
                                        One step conversion of your documentation into correspondence. One click to send
                                        to external stakeholders.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="card-outer">
                            <div className="card">
                                <div className="img-block">
                                    <span>
                                        <img src={images.slider8} alt="Image" />
                                    </span>
                                </div>
                                <div className="card-content">
                                    <h6>Fluid positive cashflow</h6>
                                    <p>Be paid for your work every fortnight. Easy tax reports for your accountant.</p>
                                </div>
                            </div>
                        </div>
                    </Slider>
                </div>
            </Container>
        </section>
    );
};

export default React.memo(HowItWorks);
